export var composeValidators = function () {
    var validators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
    }
    return function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        return validators
            .filter(Boolean)
            .reduceRight(function (error, validator) { return error || validator.apply(void 0, values); }, undefined);
    };
};
export var validateEmail = function (email) {
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return String(email).length <= 50 && regex.test(String(email).toLowerCase());
};
export var validateUkPhone = function (phone) {
    var regex = /^(?=[\w\d\+\(])([a-zA-Z\d+\s()+.-]){10,20}$/;
    return regex.test(String(phone).slice().toLowerCase());
};
export var isEmailValid = function (empty, invalid, required) {
    if (empty === void 0) { empty = 'email cannot be empty'; }
    if (invalid === void 0) { invalid = 'Invalid email format'; }
    if (required === void 0) { required = false; }
    return function (email) {
        if (!email || email == '') {
            return required ? empty : undefined;
        }
        else {
            return validateEmail(email) ? undefined : invalid;
        }
    };
};
export var isPhoneValid = function (empty, invalid, required) {
    if (empty === void 0) { empty = 'phone number cannot be empty'; }
    if (invalid === void 0) { invalid = 'Invalid phone number format'; }
    if (required === void 0) { required = false; }
    return function (phone) {
        if (!phone || phone == '') {
            return required ? empty : undefined;
        }
        else {
            return validateUkPhone(phone) ? undefined : invalid;
        }
    };
};
export var executeClientValidation = function (validate) { return function (email, allValues) { return validate && validate(email, allValues); }; };
//# sourceMappingURL=validators.js.map